import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { faCartShopping, faBookmark, faChevronRight, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { CartService } from 'src/app/services/cart.service';
import { ReservasService } from 'src/app/services/reservas.service';

@Component({
  selector: 'app-event-sale',
  templateUrl: './event-sale.component.html',
  styleUrls: ['./event-sale.component.scss']
})
export class EventSaleComponent implements OnInit, OnDestroy {
  reservationId: number | null = null;
  cartCollapsed = false;
  totalCartQuantity = 0;
  totalReservationQuantity = 0;

  faCart = faCartShopping;
  faBookmark = faBookmark;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;

  private cartSub: Subscription;
  private collapsedSub: Subscription;
  private reservationQtySub: Subscription;

  constructor(private activatedRoute: ActivatedRoute, private cartService: CartService, private reservasService: ReservasService) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const rid = params['reservationId'];
      this.reservationId = rid ? Number(rid) : null;
    });

    this.cartSub = this.cartService.cartStateObs$.subscribe((state) => {
      const lines = state?.cart_lines || [];
      this.totalCartQuantity = lines.reduce((acc: number, l: any) => acc + (l.quantity || 1), 0);
    });

    this.collapsedSub = this.cartService.cartCollapsed$.subscribe((collapsed) => {
      this.cartCollapsed = collapsed;
    });

    this.reservationQtySub = this.reservasService.reservationQuantity$.subscribe((qty) => {
      this.totalReservationQuantity = qty;
    });
  }

  ngOnDestroy(): void {
    this.cartSub?.unsubscribe();
    this.collapsedSub?.unsubscribe();
    this.reservationQtySub?.unsubscribe();
  }

  toggleCart(): void {
    this.cartCollapsed = !this.cartCollapsed;
  }
}
